import { NotificationActionResponseSchema, NotificationBulkActionResponseSchema, NotificationListResponseSchema, UnreadNotificationCountResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function listNotifications(accountId, options) {
    const params = new URLSearchParams();
    if (options?.unreadOnly)
        params.set('unreadOnly', 'true');
    if (options?.category)
        params.set('category', options.category);
    if (options?.cursor)
        params.set('cursor', options.cursor);
    if (options?.limit !== undefined)
        params.set('limit', String(options.limit));
    const qs = params.toString();
    return api(`/accounts/${accountId}/notifications${qs ? `?${qs}` : ''}`, NotificationListResponseSchema);
}
export function getUnreadNotificationCount(accountId) {
    return api(`/accounts/${accountId}/notifications/unread-count`, UnreadNotificationCountResponseSchema);
}
export function markNotificationRead(accountId, notificationId) {
    return api(`/accounts/${accountId}/notifications/${notificationId}/read`, NotificationActionResponseSchema, {
        method: 'POST',
    });
}
export function markAllNotificationsRead(accountId) {
    return api(`/accounts/${accountId}/notifications/read-all`, NotificationBulkActionResponseSchema, {
        method: 'POST',
    });
}
export function archiveReadNotifications(accountId) {
    return api(`/accounts/${accountId}/notifications/archive-read`, NotificationBulkActionResponseSchema, {
        method: 'POST',
    });
}
export function archiveNotification(accountId, notificationId) {
    return api(`/accounts/${accountId}/notifications/${notificationId}/archive`, NotificationActionResponseSchema, {
        method: 'POST',
    });
}
